module.exports = __webpack_public_path__ + "img/warn_11.25e376c5.png";